/**
 * Footer Component
 *
 * Consistent footer across all pages (except immersive pages like QuizPlay).
 * Simple, minimal design with useful links and copyright.
 */

import { Link } from "react-router-dom";
import { Database, Library, TrendingUp } from "lucide-react";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-card mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left: Links */}
          <nav className="flex items-center gap-6 text-sm">
            <Link
              to="/geojson/browse"
              className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Database className="w-4 h-4" />
              Browse Datasets
            </Link>
            <Link
              to="/quiz/my-quizzes"
              className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Library className="w-4 h-4" />
              My Quizzes
            </Link>
            <Link
              to="/progress"
              className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              <TrendingUp className="w-4 h-4" />
              Progress
            </Link>
          </nav>

          {/* Right: Copyright */}
          <div className="text-xs text-muted-foreground">
            MapQuizzr © {currentYear}
          </div>
        </div>
      </div>
    </footer>
  );
}
